import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { kc } from '../keycloakConfig'; //kc is coming from your keycloak setup
import { resetUserPassword } from '../commonApi';

const ResetUserPassword = ({ onClose }) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const keycloakUserId = localStorage.getItem('keycloakUserId'); // Get userId from localStorage

  const handleCloseModal = () => { onClose(); };

  const handleUpdatePassword = async (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      toast.error('Password & Confirm Password do not match!');
      return;
    }

    const accessToken = kc.token; // Get token from keycloak
    const tenantId = localStorage.getItem('tenantId'); // Fetch tenantId from localStorage

    try {
      // Use the resetUserPassword function from commonApi
      await resetUserPassword(keycloakUserId, newPassword, accessToken, tenantId);
      toast.success('Password updated successfully');
      onClose(); // Close modal after successful update
    } catch (error) {
      toast.error('Error updating password');
      console.error('Error updating password:', error);
    }
  };

  return (
    <div className="password-update-form">
      <form onSubmit={handleUpdatePassword}>
        <div className="form-group">
          <label htmlFor="newPassword">New Password:</label>
          <input
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label htmlFor="confirmPassword">Confirm New Password:</label>
          <input
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        <div className="d-flex justify-content-end mt-3">
          <button type="button" className="btn light_primary_btn me-3" onClick={handleCloseModal}>
            Cancel
          </button>
          <button type="submit" className="btn primary_btn btn-loader">Save</button>
        </div>
      </form>
    </div>
  );
};

export default ResetUserPassword;
